import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="pt-[148px] min-h-screen flex items-center justify-center px-5" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full p-10 text-center" style={{ background: "var(--white)", border: "1px solid var(--border)" }}>
        <XCircle className="mx-auto" size={56} style={{ color: "var(--ink-2)" }} />
        <h1 className="font-display font-black text-3xl mt-6">Paiement annulé</h1>
        <p className="mt-4 text-lg" style={{ color: "var(--ink-2)" }}>
          Aucun montant n'a été débité. Vous pouvez réessayer ou demander un devis.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/catalogue" className="btn-primary px-8 py-4 font-semibold">Retour au catalogue</Link>
          <Link to="/contact" className="btn-outline px-8 py-4 font-semibold">Demander un devis</Link>
        </div>
      </div>
    </div>
  );
}
